import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "panel"
    }}>{`Panel`}</h1>
    <p>{`A panel is used to display information and options that are persistent and can be shown without blocking user interactions with the active document.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "452px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "193.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/xd/uxp/static/3909210c9a9ca0fd9bd98b9b7e50c75b/5530d/panel.webp 320w", "/xd/uxp/static/3909210c9a9ca0fd9bd98b9b7e50c75b/a0edd/panel.webp 452w"],
            "sizes": "(max-width: 452px) 100vw, 452px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/xd/uxp/static/3909210c9a9ca0fd9bd98b9b7e50c75b/dd4a7/panel.png 320w", "/xd/uxp/static/3909210c9a9ca0fd9bd98b9b7e50c75b/80d88/panel.png 452w"],
            "sizes": "(max-width: 452px) 100vw, 452px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/xd/uxp/static/3909210c9a9ca0fd9bd98b9b7e50c75b/80d88/panel.png",
            "alt": "Example of a panel",
            "title": "Example of a panel",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`Panels appear on the left-hand side of the app when user clicks on the Plugins icon at the bottom-left side. Panels do not prevent user interaction with the underlying document and can listen for the user's selection changes. Panels are dismissed in any one of the following manners:`}</p>
    <ul>
      <li parentName="ul">{`The user clicks on the "back arrow" button at the top of XD's Plugins panel`}</li>
      <li parentName="ul">{`The user clicks on one of the other options for the left hand side of the app, such as the Layers panel or Assets panel`}</li>
      <li parentName="ul">{`The user runs a different plugin from the `}<em parentName="li">{`Plugins`}</em>{` menu`}</li>
    </ul>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`Building the user interface for panels is very similar to modals. Refer to `}<a parentName="p" {...{
        "href": "/xd/uxp/develop/reference/ui/dialogs/#usage"
      }}>{`Modal dialog usage`}</a>{`.`}</p>
    <h2 {...{
      "id": "building-panels"
    }}>{`Building Panels`}</h2>
    <p>{`You can build panels using any method that creates an HTML5 DOM structure. This means you can use `}<inlineCode parentName="p">{`document.createElement`}</inlineCode>{`, `}<inlineCode parentName="p">{`innerHTML`}</inlineCode>{`, jQuery, React, and other frameworks.`}</p>
    <p>{`Let's examine a simple panel and how we might create it:`}</p>
    <p>{`{% tabs sample="Sample", html="HTML", js="JS" %}`}</p>
    <p>{`{% content "sample" %}`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "502px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.18749999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/xd/uxp/static/cc5ff6086dde74ae20300eb231bffc9b/5530d/panel-example.webp 320w", "/xd/uxp/static/cc5ff6086dde74ae20300eb231bffc9b/6a9f2/panel-example.webp 502w"],
            "sizes": "(max-width: 502px) 100vw, 502px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/xd/uxp/static/cc5ff6086dde74ae20300eb231bffc9b/dd4a7/panel-example.png 320w", "/xd/uxp/static/cc5ff6086dde74ae20300eb231bffc9b/c1d3e/panel-example.png 502w"],
            "sizes": "(max-width: 502px) 100vw, 502px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/xd/uxp/static/cc5ff6086dde74ae20300eb231bffc9b/c1d3e/panel-example.png",
            "alt": "A Simple panel",
            "title": "A Simple panel",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`{% content "html" %}`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<style>
  .break {
    flex-wrap: wrap;
  }
  label.row > * {
    margin: 3px 0;
  }
  label.row > span {
    color: #8e8e8e;
    width: 20px;
    text-align: right;
    font-size: 9px;
  }
  label.row input {
    flex: 1 1 auto;
  }
  label.row input[type="number"] {
    flex-basis: 32px;
  }
  div input[type="checkbox"] {
    flex: 0 0 20px;
  }
  form footer > * {
    position: relative;
    left: 8px;
  }
</style>
<form method="dialog" id="main">
  <label class="row" id="fldButtonText">
    <span>Aa</span>
    <input
      type="text"
      id="txtButtonText"
      value="Text"
      placeholder="Text"
      uxp-quiet="true"
    />
  </label>
  <div class="row break">
    <label class="row">
      <span>↕︎</span>
      <input
        type="number"
        uxp-quiet="true"
        id="txtV"
        value="10"
        placeholder="Vertical padding"
      />
    </label>
    <label class="row">
      <span>↔︎</span>
      <input
        type="number"
        uxp-quiet="true"
        id="txtH"
        value="10"
        placeholder="Horizontal padding"
      />
    </label>
    <div class="row">
      <input type="checkbox" checked id="chkColor" />
      <label class="row" id="fldColor">
        <input
          type="text"
          uxp-quiet="true"
          id="txtColor"
          value="#0000FF"
          placeholder="CSS Color"
        />
        <span>🎨</span>
      </label>
    </div>
  </div>
  <footer>
    <button id="ok" type="submit" uxp-variant="cta">Apply</button>
  </footer>
</form>
`}</code></pre>
    <p>{`{% content "js" %}`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`let panel;

function create() {
  const HTML = \`<style>
            .break {
                flex-wrap: wrap;
            }
            label.row > * {
                margin: 3px 0;
            }
            label.row > span {
                color: #8E8E8E;
                width: 20px;
                text-align: right;
                font-size: 9px;
            }
            label.row input {
                flex: 1 1 auto;
            }
            label.row input[type=number] {
                flex-basis: 32px;
            }
            div input[type=checkbox] {
                flex: 0 0 20px;
            }
            form footer > * {
                position: relative;
                left: 8px;
            }
        </style>
        <form method="dialog" id="main">
        <label class="row" id="fldButtonText">
            <span>Aa</span>
            <input type="text" id="txtButtonText" value="Text" placeholder="Text" uxp-quiet="true"/>
        </label>
        <div class="row break">
            <label class="row">
            <span>↕︎</span>
            <input type="number" uxp-quiet="true" id="txtV" value="10" placeholder="Vertical padding" />
            </label>
            <label class="row">
            <span>↔︎</span>
            <input type="number" uxp-quiet="true" id="txtH" value="10" placeholder="Horizontal padding" />
            </label>
            <div class="row">
            <input type="checkbox" checked id="chkColor" />
            <label class="row" id="fldColor">
                <input type="text" uxp-quiet="true" id="txtColor" value="#0000FF" placeholder="CSS Color" />
                <span>🎨</span>
            </label>
            </div>
        </div>
        <footer><button id="ok" type="submit" uxp-variant="cta">Apply</button></footer>
        </form>
        \`;

  panel = document.createElement("div");
  panel.innerHTML = HTML;

  return panel;
}

function show(event) {
  // create panel the first time it's shown
  if (!panel) {
    panel = create();
    event.node.appendChild(panel);
  }
}

function hide(event) {
  // in this example, we don't need to do anything when XD hides our panel
}

function update(selection, root) {
  console.log(selection.items);
}

module.exports = {
  panels: {
    example: {
      show,
      hide,
      update,
    },
  },
};
`}</code></pre>
    <p>{`{% endtabs %}`}</p>
    <p>{`Note: you can either reuse your panel's UI nodes, or destroy and recreate the panel each time it's closed. For examples of both approaches, see the `}<a parentName="p" {...{
        "href": "./show/"
      }}>{`detailed documentation on the `}<inlineCode parentName="a">{`show()`}</inlineCode>{` method`}</a>{`.`}</p>
    <h2 {...{
      "id": "handling-selection-change"
    }}>{`Handling Selection Change`}</h2>
    <p>{`As you can see in the example above, every time the user's `}<inlineCode parentName="p">{`selection`}</inlineCode>{` changes, your (optional) lifecycle method `}<inlineCode parentName="p">{`update`}</inlineCode>{` will trigger. You will have access to both `}<inlineCode parentName="p">{`selection`}</inlineCode>{` and `}<inlineCode parentName="p">{`root`}</inlineCode>{` as parameters in the function. This means that your panel can display dynamic content based on what user has selected in the document.`}</p>
    <p>{`{% tabs sampleselection="Sample", htmlselection="HTML", jsselection="JS" %}`}</p>
    <p>{`{% content "sampleselection" %}`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "462px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "47.1875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/xd/uxp/static/06951050670fe1493b231d4258d1d6a5/5530d/error.webp 320w", "/xd/uxp/static/06951050670fe1493b231d4258d1d6a5/0b6e4/error.webp 462w"],
            "sizes": "(max-width: 462px) 100vw, 462px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/xd/uxp/static/06951050670fe1493b231d4258d1d6a5/dd4a7/error.png 320w", "/xd/uxp/static/06951050670fe1493b231d4258d1d6a5/a9e02/error.png 462w"],
            "sizes": "(max-width: 462px) 100vw, 462px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/xd/uxp/static/06951050670fe1493b231d4258d1d6a5/a9e02/error.png",
            "alt": "Error message",
            "title": "Error message",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p>{`{% content "htmlselection" %}`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<style>
  .break {
    flex-wrap: wrap;
  }
  label.row > * {
    margin: 3px 0;
  }
  label.row > span {
    color: #8e8e8e;
    width: 20px;
    text-align: right;
    font-size: 9px;
  }
  label.row input {
    flex: 1 1 auto;
  }
  label.row input[type="number"] {
    flex-basis: 32px;
  }
  div input[type="checkbox"] {
    flex: 0 0 20px;
  }
  form footer > * {
    position: relative;
    left: 8px;
  }
</style>
<form method="dialog" id="main">
  <label class="row" id="fldButtonText">
    <span>Aa</span>
    <input
      type="text"
      id="txtButtonText"
      value="Text"
      placeholder="Text"
      uxp-quiet="true"
    />
  </label>
  <div class="row break">
    <label class="row">
      <span>↕︎</span>
      <input
        type="number"
        uxp-quiet="true"
        id="txtV"
        value="10"
        placeholder="Vertical padding"
      />
    </label>
    <label class="row">
      <span>↔︎</span>
      <input
        type="number"
        uxp-quiet="true"
        id="txtH"
        value="10"
        placeholder="Horizontal padding"
      />
    </label>
    <div class="row">
      <input type="checkbox" checked id="chkColor" />
      <label class="row" id="fldColor">
        <input
          type="text"
          uxp-quiet="true"
          id="txtColor"
          value="#0000FF"
          placeholder="CSS Color"
        />
        <span>🎨</span>
      </label>
    </div>
  </div>
  <footer>
    <button id="ok" type="submit" uxp-variant="cta">Apply</button>
  </footer>
</form>
`}</code></pre>
    <p>{`{% content "jsselection" %}`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`let panel;

function create() {
  const HTML = \`<style>
            .break {
                flex-wrap: wrap;
            }
            label.row > * {
                margin: 3px 0;
            }
            label.row > span {
                color: #8E8E8E;
                width: 20px;
                text-align: right;
                font-size: 9px;
            }
            label.row input {
                flex: 1 1 auto;
            }
            label.row input[type=number] {
                flex-basis: 32px;
            }
            div input[type=checkbox] {
                flex: 0 0 20px;
            }
            form footer > * {
                position: relative;
                left: 8px;
            }

        </style>
        <form method="dialog" id="main">
            <label class="row" id="fldButtonText">
                <span>Aa</span>
                <input type="text" id="txtButtonText" value="Text" placeholder="Text" uxp-quiet="true"/>
            </label>
            <div class="row break">
                <label class="row">
                    <span>↕︎</span>
                    <input type="number" uxp-quiet="true" id="txtV" value="10" placeholder="Vertical padding" />
                </label>
                <label class="row">
                    <span>↔︎</span>
                    <input type="number" uxp-quiet="true" id="txtH" value="10" placeholder="Horizontal padding" />
                </label>
                <div class="row">
                    <input type="checkbox" checked id="chkColor" />
                    <label class="row" id="fldColor">
                        <input type="text" uxp-quiet="true" id="txtColor" value="#0000FF" placeholder="CSS Color" />
                        <span>🎨</span>
                    </label>
                </div>
            </div>
            <footer><button id="ok" type="submit" uxp-variant="cta">Apply</button></footer>
        </form>
        \`;

  panel = document.createElement("div");
  panel.innerHTML = HTML;

  return panel;
}

function show(event) {
  // create panel the first time it's shown
  if (!panel) {
    panel = create();
    event.node.appendChild(panel);
  }
}

function hide(event) {
  // in this example, we don't need to do anything when XD hides our panel
}

function update(selection, root) {
  const { Text } = require("scenegraph");
  if (!(selection.items[0] instanceof Text)) {
    panel.innerHTML = \`<p>Please select a text object.</p>\`;
  }
}

module.exports = {
  panels: {
    example: {
      show,
      hide,
      update,
    },
  },
};
`}</code></pre>
    <p>{`{% endtabs %}`}</p>
    <h2 {...{
      "id": "further-reading"
    }}>{`Further Reading`}</h2>
    <p>{`Refer to the panel lifecycle method documentation to learn more about these methods:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./show/"
        }}>{`Show`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./hide/"
        }}>{`Hide`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./update/"
        }}>{`Update`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      